import { Button } from "antd";
import React from "react";
import { OneCustomer } from "../../../Stores/Customers/OneCustomer";
import { useParams } from "react-router-dom";

export default function Verify() {
  let { id } = useParams();
  const { data, updateUser, fetchData } = OneCustomer();
  return (
    <div>
      <h2>Verify</h2>
      <div>
        <p className="text-[15px] bold">
          Xaridor bilan shartnoma kafolat xati hamda boshqa kerakli xujjatlar
          imzolangan holda beriladigan daraja hissoblanadi.
        </p>

        <div>
          <h2 className="text-[12px] bold ">Etiborli bo'ling!</h2>
          {!data?.verify ? (
            <Button
              size="large"
              className="w-[100%] flex justify-start"
              icon={
                <img
                  src="https://www.notion.so/icons/verified_blue.svg?mode=dark"
                  width={25}
                  height={25}
                />
              }
              color={"default"}
              variant="filled"
              onClick={() => {
                updateUser(id, {
                  name: data?.name,
                  phone: data?.phone,
                  comment: data?.comment,
                  INN: data?.INN,
                  type: data?.type,
                  verify: true,
                });
              }}
            >
              Verify darajasini berish
            </Button>
          ) : (
            <Button
              size="large"
              className="w-[100%] flex justify-start"
              icon={
                <img
                  src="https://www.notion.so/icons/verified_blue.svg?mode=dark"
                  width={25}
                  height={25}
                />
              }
              color={"primary"}
              variant="filled"
              onClick={() => {
                updateUser(id, {
                  name: data?.name,
                  phone: data?.phone,
                  comment: data?.comment,
                  INN: data?.INN,
                  type: data?.type,
                  verify: false,
                });
              }}
            >
              Verifyni bekor qilish
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
